/**
 * Searchable font catalog for the Brand Kit pickers. All entries are Google
 * Fonts families — the overlay renderer loads whatever family is chosen via
 * a Google Fonts stylesheet (see render-overlay's ensureFontsLoaded), so
 * anything on this list works in previews AND exports. ComboboxInput also
 * allows free typing, so an off-catalog family is still possible.
 */
export const FONT_CATALOG: string[] = [
  "Abril Fatface",
  "Alfa Slab One",
  "Anton",
  "Archivo",
  "Archivo Black",
  "Archivo Narrow",
  "Asap",
  "Assistant",
  "Barlow",
  "Barlow Condensed",
  "Bebas Neue",
  "Bitter",
  "Bricolage Grotesque",
  "Cabin",
  "Cairo",
  "Catamaran",
  "Caveat",
  "Chivo",
  "Cinzel",
  "Comfortaa",
  "Cormorant",
  "Cormorant Garamond",
  "Crimson Text",
  "DM Sans",
  "DM Serif Display",
  "Dancing Script",
  "EB Garamond",
  "Exo 2",
  "Figtree",
  "Fira Sans",
  "Fjalla One",
  "Fraunces",
  "Heebo",
  "Hind",
  "IBM Plex Mono",
  "IBM Plex Sans",
  "IBM Plex Serif",
  "Inconsolata",
  "Inter",
  "Inter Tight",
  "Josefin Sans",
  "Jost",
  "Kanit",
  "Karla",
  "Lato",
  "League Spartan",
  "Lexend",
  "Libre Baskerville",
  "Libre Franklin",
  "Lobster",
  "Lora",
  "Manrope",
  "Marcellus",
  "Merriweather",
  "Montserrat",
  "Mukta",
  "Mulish",
  "Nanum Gothic",
  "Noto Sans",
  "Noto Serif",
  "Nunito",
  "Nunito Sans",
  "Onest",
  "Open Sans",
  "Oswald",
  "Outfit",
  "Overpass",
  "PT Sans",
  "PT Serif",
  "Pacifico",
  "Passion One",
  "Permanent Marker",
  "Plus Jakarta Sans",
  "Poppins",
  "Prompt",
  "Public Sans",
  "Quicksand",
  "Raleway",
  "Righteous",
  "Roboto",
  "Roboto Condensed",
  "Roboto Mono",
  "Roboto Slab",
  "Rubik",
  "Sarabun",
  "Schibsted Grotesk",
  "Sen",
  "Shadows Into Light",
  "Sora",
  "Source Sans 3",
  "Source Serif 4",
  "Space Grotesk",
  "Space Mono",
  "Spectral",
  "Syne",
  "Teko",
  "Tinos",
  "Titillium Web",
  "Ubuntu",
  "Unbounded",
  "Urbanist",
  "Work Sans",
  "Yellowtail",
  "Zilla Slab",
]
